function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
export class IntlError extends Error {
    constructor(message){
        super(`[@sail/intl] ${message}`);
    }
}
class ReactIntlBaseError extends IntlError {
    constructor(reactIntlError){
        const message = reactIntlError.message.replace(/\[React Intl[^\]]*?\]\s?/, '');
        super(message);
    }
}
class ReactIntlMessageFormatBaseError extends IntlError {
    constructor(reactIntlError){
        const message = reactIntlError.message.replace(/\[formatjs Error:[^\]]*?\]\s?/, '');
        super(message);
    }
}
export class IntlMissingLocaleData extends IntlError {
    constructor(locale){
        super(`Missing "${locale}" locale data!`);
    }
}
export class IntlFormatMessageError extends IntlError {
}
// react-intl errors
export class IntlMissingTranslationError extends ReactIntlBaseError {
    constructor(reactIntlError, descriptor){
        super(reactIntlError);
        _define_property(this, "descriptor", void 0);
        this.descriptor = descriptor;
    }
}
export class IntlMessageFormatError extends ReactIntlBaseError {
}
export class IntlMissingDataError extends ReactIntlBaseError {
}
export class IntlInvalidConfigError extends ReactIntlBaseError {
}
export class IntlMissingMessageError extends IntlError {
    constructor(){
        super('A message must be provided to format a message.');
    }
}
// intl-messageformat errors
export class IntlMessageFormatInvalidValueError extends ReactIntlMessageFormatBaseError {
}
export class IntlMessageFormatMissingValueError extends ReactIntlMessageFormatBaseError {
}
export class IntlMessageFormatMissingIntlAPIError extends ReactIntlMessageFormatBaseError {
}
export class IntlLocaleDataError extends IntlError {
    constructor(message){
        super(`${message} Make sure to initialize \`@sail/intl\` with the correct locale data.`);
    }
}
export class IntlUnsupportedTimeZoneError extends IntlError {
    constructor(timeZone){
        super(`Unsupported time zone \`${timeZone}\`. See the full list of supported time zones at https://github.com/moment/moment-timezone/blob/0.5.30/data/packed/2014a.json`);
    }
}

//# sourceMappingURL=errors.js.map